import React, { useEffect, useState } from "react";
import ReservationHeader from "./ReservationHeader";
import ReservationDisplayer from "./ReservationDisplayer";
import NewRes from "./NewRes";
import ReservationSSE from "./ReservationSSE";
import {
  getReservationsByDate,
  getWaitlist,
  getCancelledWaitlist,
  patchReservation,
  postAdminReservation,
  updateReservation,
  deleteReservation,
} from "../../../../api";
import ContextMenu from "components/ContextMenu";
import { Toaster, toast } from "sonner";
import ResModal from "./ResModal";
import { dateToString } from "dateUtils";
import { AnimatePresence, motion } from "motion/react";
import ViewSwitcher from "../Waitlist/ViewSwitcher";
import WaitlistSSE from "../Waitlist/WaitlistSSE";
import WaitlistPage from "../Waitlist/WaitlistModal";
import "../Waitlist/Waitlist.css";

function Reversations() {
  const [reservations, setReservations] = useState([]);
  const [newResOpen, setNewRes] = useState(false);
  const [resModalOpen, setResModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  function getCurrentShift() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    if (hours < 17 || (hours === 17 && minutes === 0)) {
      return "Lunch";
    } else {
      return "Dinner";
    }
  }

  const [shift, setShift] = useState(getCurrentShift());

  const toggleShift = () => {
    setShift((prevShift) => (prevShift === "Lunch" ? "Dinner" : "Lunch"));
  };

  const shiftReservations = reservations.filter((reservation) => {
    const [hoursStr] = reservation.time.split(":");
    const hours = parseInt(hoursStr, 10);

    if (shift === "Lunch") {
      return hours < 17;
    } else {
      return hours >= 16;
    }
  });

  const liveRes = shiftReservations.filter(
    (reservation) =>
      reservation.state !== "cancel" && reservation.state !== "noshow"
  );
  const cancelledRes = shiftReservations.filter(
    (reservation) =>
      reservation.state === "cancel" || reservation.state === "noshow"
  );

  const today = () => {
    const today = new Date();

    const options = {
      timeZone: "America/Chicago",
      hour12: false,
    };
    const chicagoDateTime = today.toLocaleString("en-US", options);
    const todayDateObj = new Date(chicagoDateTime);

    return todayDateObj;
  };

  const handleDateClick = () => {
    setDate(today());
  };

  const [date, setDate] = useState(today());

  const [view, setView] = useState("reservations"); // "reservations" | "waitlist"
  const [waitlistActive, setWaitlistActive] = useState([]);
  const [waitlistCancelled, setWaitlistCancelled] = useState([]);
  const [waitlistFormOpen, setWaitlistFormOpen] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const waitlistCount = waitlistActive.filter((e) => e.state !== "seated").length;

  const { data: reservation } = ReservationSSE();
  const { data: waitlistEvent } = WaitlistSSE();

  const areDatesEqual = (d1, d2) => {
    return d1.toDateString() === d2.toDateString();
  };

  useEffect(() => {
    if (reservation) {
      const reservationDate = new Date(reservation.date);
      if (areDatesEqual(reservationDate, date)) {
        setReservations((prevReservations) => {
          const reservationIndex = prevReservations.findIndex(
            (res) => res._id === reservation._id
          );

          if (reservationIndex > -1) {
            const updatedReservations = [...prevReservations];
            updatedReservations[reservationIndex] = reservation;
            return updatedReservations;
          } else {
            return [...prevReservations, reservation];
          }
        });
      }
    }
  }, [reservation, date]);

  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        const active = await getWaitlist(ac.signal);
        if (Array.isArray(active)) setWaitlistActive(active);
      } catch (e) {}
      try {
        const cancelled = await getCancelledWaitlist(ac.signal);
        if (Array.isArray(cancelled)) setWaitlistCancelled(cancelled);
      } catch (e) {}
    })();
    return () => ac.abort();
  }, [view, waitlistEvent]);

  function sumGuests(reservations) {
    return reservations.reduce(
      (acc, reservation) => acc + reservation.numGuests,
      0
    );
  }

  function addResLocal(newRes) {
    const updatedReservations = [...reservations, newRes];
    updatedReservations.sort((a, b) => new Date(a.date) - new Date(b.date));
    setReservations(updatedReservations);
  }

  function handleSeatedFromWaitlist(reservation) {
    if (!reservation) return;
    if (!areDatesEqual(new Date(reservation.date), date)) return;
    setReservations((prev) => {
      if (prev.some((r) => r._id === reservation._id)) return prev;
      return [...prev, reservation].sort((a, b) => new Date(a.date) - new Date(b.date));
    });
  }

  async function submitRes(res) {
    setSubmitting(true);
    try {
      const response = await postAdminReservation(res);
      if (response.status === 201) {
        toast.success("Reservation created");
        const reservationDate = new Date(res.date);
        if (areDatesEqual(reservationDate, date)) addResLocal(response.data);
        setNewRes(false);
        setSubmitting(false);
      }
    } catch (error) {
      toast.error("Failed to create new reservation");
      console.error(error);
      setSubmitting(false);
    }
  }

  function openResContextMenu(e, res) {
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      items: [
        {
          label: "Delete",
          danger: true,
          onSelect: () => deleteRes(res),
        },
      ],
    });
  }

  async function deleteRes(res) {
    try {
      await deleteReservation(res._id);
      setReservations((prev) => prev.filter((r) => r._id !== res._id));
      toast.success("Reservation deleted");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete reservation");
    }
  }

  async function patchRes(res, state) {
    const id = res._id;

    try {
      const response = await patchReservation(id, state, "Employee");

      if (response.status === 200) {
        const updatedReservation = response.data;

        setReservations((prev) =>
          prev.map((r) =>
            r._id === updatedReservation._id ? updatedReservation : r
          )
        );
      }
    } catch (error) {
      if (!navigator.onLine) {
        toast.error(
          `Failed to mark reservation as ${state} -- there is no internet on this device`
        );
      } else {
        const toastError =
          state === "cancel"
            ? "Failed to cancel the reservation"
            : `Failed to mark reservation as ${state}`;
        toast.error(toastError);
      }
    }
  }

  async function loadReservations(date, signal) {
    setLoading(true);
    setReservations([]);
    try {
      const response = await getReservationsByDate(date, signal);
      const sortedReservations = response.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      setReservations(sortedReservations);
      console.log(sortedReservations);
    } catch (error) {
      if (error.name !== "AbortError" && !signal?.aborted) {
        toast.error(`Failed to load reservations for ${dateToString(date)}`);
        console.log(error);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
      return true;
    }
  }

  async function updateRes(updatedRes) {
    try {
      const response = await updateReservation(updatedRes._id, updatedRes);
      if (response.status === 200) {
        toast.success("Reservation updated");
        setResModal(false);
        const data = response.data;

        const updResDate = new Date(data.date);
        const areDatesEqual = updResDate.toDateString() === date.toDateString();

        setReservations((prev) => {
          if (areDatesEqual) {
            return prev.map((res) => (res._id === data._id ? data : res));
          } else {
            return prev.filter((res) => res._id !== data._id);
          }
        });
      }
    } catch (error) {
      toast.error("Failed to updated reservation");
      console.log(error);
    }
  }

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    loadReservations(date, signal);

    return () => {
      abortController.abort();
    };
  }, [date]);

  document.body.classList.toggle("no-scroll", newResOpen);

  async function reloadReservations(date, signal) {
    try {
      const response = await getReservationsByDate(date, signal);
      const sortedReservations = response.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      setReservations(sortedReservations);
      return true;
    } catch (error) {
      if (error.name !== "AbortError" && !signal?.aborted) {
        toast.error(`Failed to load reservations for ${dateToString(date)}`);
        console.log(error);
      }
      return false;
    }
  }

  const handleReload = async () => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    await reloadReservations(date, signal);
  };

  function closeNewRes() {
    setNewRes(false);
  }

  return (
    <div className="reservations-container">
      <AnimatePresence>
        {newResOpen && (
          <NewRes
            selfClose={closeNewRes}
            setNewRes={setNewRes}
            submitRes={submitRes}
            submitting={submitting}
            defaultDate={date}
          />
        )}
        {resModalOpen && (
          <ResModal
            selfClose={() => setResModal(false)}
            updateRes={updateRes}
            res={resModalOpen}
          />
        )}
      </AnimatePresence>
      <Toaster richColors position="top-center" />
      {view === "reservations" ? (
        <>
          <div className="reservations-header">
            <div className={`res-header`}>
              <ReservationHeader
                date={date}
                setDate={setDate}
                handleDateClick={handleDateClick}
                numGuests={sumGuests(liveRes)}
                numRes={liveRes.length}
                shift={shift}
                toggleShift={toggleShift}
                setNewRes={setNewRes}
                loading={loading}
                today={today}
              />
            </div>
          </div>
          <motion.div
            key={`res-body-${view}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            <ReservationDisplayer
              reservations={reservations}
              liveRes={liveRes}
              cancelledRes={cancelledRes}
              setReservations={setReservations}
              patchRes={patchRes}
              setResModal={setResModal}
              loading={loading}
              handleReload={handleReload}
              onContextMenu={openResContextMenu}
            />
          </motion.div>
        </>
      ) : (
        <WaitlistPage
          active={waitlistActive}
          cancelled={waitlistCancelled}
          setActive={setWaitlistActive}
          setCancelled={setWaitlistCancelled}
          onSeated={handleSeatedFromWaitlist}
          onFormOpenChange={setWaitlistFormOpen}
        />
      )}
      {!waitlistFormOpen && (
        <>
          <div className="view-switcher-fade" aria-hidden="true" />
          <ViewSwitcher
            view={view}
            count={waitlistCount}
            onChange={setView}
          />
        </>
      )}
      {contextMenu && (
        <ContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          items={contextMenu.items}
          onClose={() => setContextMenu(null)}
        />
      )}
    </div>
  );
}

export default Reversations;
